import React from "react";

import { faAdd, faBracketsCurly } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { EmptyState } from "src/design-system/EmptyState";

export type JsonSchemaEmptyStateProps = {
  immutable: boolean;
  onAddField: () => void;
  onOpenRawJsonView?: () => void;
};

export const JsonSchemaEmptyState: React.FC<JsonSchemaEmptyStateProps> = ({
  immutable,
  onAddField,
  onOpenRawJsonView,
}) => {
  return (
    <EmptyState
      dataLoc="json-schema-empty-state"
      icon={faBracketsCurly}
      headline="Create structured output"
      description="Click below to start creating your structured output by adding a field
        or creating from JSON schema."
      action={
        <div className="flex items-center gap-4">
          <div className="w-[120px]">
            <Button
              dataLoc="add-jsonschema-field"
              disabled={immutable}
              iconLeft={faAdd}
              size="sm"
              variant="secondary"
              fullWidth
              onClick={onAddField}
            >
              Add field
            </Button>
          </div>
          {onOpenRawJsonView && (
            <>
              <span className="font-inter-normal-12px text-gray-400">or</span>
              <div className="w-[120px]">
                <Button
                  dataLoc="open-json-schema-editor"
                  disabled={immutable}
                  iconLeft={faBracketsCurly}
                  size="sm"
                  variant="secondary"
                  fullWidth
                  onClick={onOpenRawJsonView}
                >
                  JSON schema
                </Button>
              </div>
            </>
          )}
        </div>
      }
    />
  );
};
